<template lang="html">
  <div class="modal-wrapper">
    <table v-if="windowWidth >= 768 && transactions.length > 0">
      <thead>
        <tr>
          <td style="cursor: pointer;" @click="handleSort('off_buyer')">
            {{ $t("profile.purchase.buyer") }}
            <img
              v-if="sort === 'off_buyer'"
              :class="{ asc: sortDirection !== 'asc' }"
              src="@/assets/icons/dropdownArrow.png"
              alt="arrow"
            />
          </td>
          <td style="cursor: pointer;" @click="handleSort('off_date')">
            {{ $t("profile.purchase.date") }}
            <img
              v-if="sort === 'off_date'"
              :class="{ asc: sortDirection !== 'asc' }"
              src="@/assets/icons/dropdownArrow.png"
              alt="arrow"
            />
          </td>
          <td style="cursor: pointer;" @click="handleSort('off_quantity')">
            {{ $t("profile.purchase.quantity") }}
            <img
              v-if="sort === 'off_quantity'"
              :class="{ asc: sortDirection !== 'asc' }"
              src="@/assets/icons/dropdownArrow.png"
              alt="arrow"
            />
          </td>
          <td>{{ $t("profile.purchase.term") }}</td>
          <td style="cursor: pointer;" @click="handleSort('off_status')">
            {{ $t("profile.purchase.status") }}
            <img
              v-if="sort === 'off_status'"
              :class="{ asc: sortDirection !== 'asc' }"
              src="@/assets/icons/dropdownArrow.png"
              alt="arrow"
            />
          </td>
          <td style="width: 40px"></td>
          <td style="width: 40px"></td>
        </tr>
      </thead>
      <tbody>
        <tr
          @click="openBuyerModal(transaction)"
          v-for="(transaction, index) in transactions"
          :key="index"
        >
          <td>
            {{ transaction.usr_name }}
          </td>
          <td>
            {{ transaction.off_date }}
          </td>
          <td>
            {{ transaction.off_quantity }}
          </td>
          <td>
            {{ getTranslation(transaction.off_type) }}
          </td>
          <td>
            <TagDisplay :color="getTagColor(transaction.off_status)">
              {{ getStatus(transaction.off_status) }}
            </TagDisplay>
          </td>
          <td v-if="rejectable" @click="openConfirmModal(transaction, $event)">
            <div v-if="transaction.cancelable === 1" class="icon-wrapper">
              <img
                :title="$t('main.reject')"
                src="@/assets/icons/reject.png"
                alt="reject icon"
              />
            </div>
          </td>
          <td v-else></td>
          <td
            v-if="transaction.can_hide === 1"
            @click="archive(transaction, $event)"
          >
            <div class="icon-wrapper">
              <img src="@/assets/icons/closeRed.png" alt="close icon" />
            </div>
          </td>
          <td v-else></td>
        </tr>
      </tbody>
    </table>
    <table
      class="mobile-table"
      v-if="windowWidth < 768 && transactions.length > 0"
    >
      <!-- <div class="icon-wrapper">
          <img src="@/assets/icons/closeRed.png" alt="close icon">
        </div> -->
      <tbody>
        <tr
          @click="openBuyerModal(transaction)"
          v-for="(transaction, index) in transactions"
          class="mobile-tr"
          :key="index"
        >
          <td>
            <span class="bold-td-text">{{ transaction.usr_name }}</span>
          </td>
          <td class="x-btn"></td>
          <td class="regular-td-text">{{ transaction.off_quantity }} kom.</td>
          <td class="light-grey">
            {{ getTranslation(transaction.off_type) }}
            <span
              v-if="rejectable && transaction.off_status === 1"
              @click="openConfirmModal(transaction, $event)"
            >
              <img src="@/assets/icons/reject.png" alt="reject icon" />
            </span>
            <span v-else></span>
          </td>
          <td class="status-color">
            <span class="date">
              {{ transaction.off_date.substring(0, 10) }}
            </span>
            <span>
              <TagDisplay :color="getTagColor(transaction.off_status)">
                {{ getStatus(transaction.off_status) }}
              </TagDisplay>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <span style="margin-left: 15px" v-if="transactions.length === 0">
      {{ $t("main.noOffers") }}
    </span>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import TagDisplay from "../shared/TagDisplay.vue";
export default {
  name: "productBuyers",
  components: {
    TagDisplay
  },
  props: {
    modalData: {
      required: true
    },
    rejectable: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      transactions: [],
      windowWidth: window.innerWidth,
      sort: "off_date",
      sortDirection: "desc"
    };
  },
  mounted() {
    this.getBuyers();
    window.addEventListener("resize", this.onResize);
    eventBus.$on("refresh", () => {
      this.getBuyers();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
    eventBus.$off("refresh");
  },
  methods: {
    handleSort(str) {
      if (this.sort === str) {
        this.sortDirection = this.sortDirection === "desc" ? "asc" : "desc";
      } else {
        this.sort = str;
        this.sortDirection = "desc";
      }
      this.getBuyers();
    },
    archive(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.archiveOffer"),
        ok: () => {
          this.archiveOffer(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    archiveOffer(data) {
      let params = {
        off_id: data.off_id
      };
      api
        .deleteOfferFromArchive(params)
        .then(res => {
          this.getBuyers();
        })
        .catch(e => {
          console.log(e);
        });
    },
    openBuyerModal(user) {
      let params = {
        modalData: user,
        component: "buyerDetails"
      };
      eventBus.$emit("openModal", params);
    },
    openConfirmModal(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.rejectOfferTitle"),
        ok: () => {
          this.changeStatus(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    changeStatus(data) {
      let params = {
        id: data.off_id
      };
      api
        .changeOffer(params)
        .then(res => {
          this.$toast.success(this.$t("main.rejectOfferSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          this.$toast.error(this.$t("main.rejectOfferError"), {
            duration: 8000
          });
        })
        .finally(() => {
          this.getBuyers();
        });
    },
    getBuyers() {
      let params = {
        pro_id: this.modalData.pro_id,
        view: true
      };
      if (this.sort) {
        params.sort = this.sort;
        params.sort_direction = this.sortDirection;
      }
      api
        .getProductTransactions(params)
        .then(res => {
          this.transactions = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getStatus(status) {
      if (status === 1) {
        if (this.modalData.expired === 1 || this.modalData.sold_out === 1) {
          return this.$t("profile.buyers.statusSoldFinished");
        }
        return this.$t("profile.buyers.statusSold");
      } else if (status === 2) {
        return this.$t("profile.buyers.statusBuyerGaveUp");
      } else if (status === 3) {
        return this.$t("profile.buyers.statusRejected");
      } else if (status === 4) {
        return this.$t("profile.buyers.statusRejectedAdmin");
      } else if (status === 5) {
        return this.$t("profile.buyers.statusContract");
      } else {
        return this.$t("profile.buyers.statusUnknown");
      }
    },
    getTagColor(status) {
      if (status === 1) {
        return "green";
      } else if (status === 2) {
        return "gray";
      } else if (status === 3) {
        return "red";
      } else if (status === 4) {
        return "red";
      } else if (status === 5) {
        return "blue";
      } else {
        return "gray";
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/tableStyles.scss";
table {
  border: none;
  thead {
    text-transform: uppercase;
    tr {
      cursor: default !important;
    }
  }
  thead td img {
    padding-bottom: 3px;
  }
  thead td img.asc {
    transform: rotate(180deg);
    padding-bottom: 0px;
    padding-top: 3px;
  }
  tbody tr {
    cursor: pointer;
  }
}
.modal-wrapper {
  width: 100%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  thead td {
    color: $blue-400;
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
}
.mobile-table {
  position: relative;
  tbody tr {
    background: none !important;
    display: flex;
    flex-wrap: wrap;
  }
  tbody tr td {
    border-bottom: none;
    vertical-align: top;
    width: 50%;
    height: 100%;
    padding: 5px;
  }
  tr td:last-child {
    width: 100%;
  }
  .icon-wrapper {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.mobile-tr {
  border-bottom: 1px solid $gray-700;
  padding-bottom: 5px;
  &:last-child {
    border-bottom: none;
  }
}
.bold-td-text {
  font-weight: 700;
  font-size: 17px;
}
.regular-td-text {
  font-weight: 500;
  font-size: 14px;
}
.light-grey {
  color: #9b9b9b;
  text-align: right;
  vertical-align: top;
  font-weight: 400;
  font-size: 13px;
}
.status-color {
  color: #8e3e4c;
  /* text-align: right; */
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  .date {
    color: #9b9b9b;
    font-weight: 400;
    font-size: 13px;
  }
}
.x-btn {
  text-align: right;
}
</style>
